define(["jquery","mage/apply/main","Magento_Ui/js/lib/knockout/bootstrap"],(function($,a){"use strict";$.ajaxSetup({cache:!1}),$(a.apply)}));